// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1eq9_","amount":"Amount_amount__2AuPE","tip":"Amount_tip__3wD5W","tipHeader":"Amount_tipHeader__3tSui","tipsWrap":"Amount_tipsWrap__3rB7e"};